import CommonHeader, { TabConfig } from '@/components/common/CommonHeader';
import { palette } from '@/modules/defines/styles';

const tabs: TabConfig[] = [
  { label: '공간 관리', path: '/space' },
  { label: '이벤트 관리', path: '/event' },
  { label: '유저 관리', path: '/user' },
  { label: '통계', path: '/data' },
];

const DaekyoHeader = () => {
  return (
    <CommonHeader
      title="Daekyo ADMIN"
      backgroundColor={palette.systemBlue}
      hoverColor="#0066b3"
      tabs={tabs}
      sessionCode="daekyo"
      baseRoute="/daekyo"
    />
  );
};

export default DaekyoHeader;
